import { createSelector } from 'reselect'
import { selectCurrentTicketIsFollowing } from 'selectors/tickets'

export const selectShouldSendFollowRequest = createSelector(
  selectCurrentTicketIsFollowing,
  (_state, pendingAction) => pendingAction,
  (IsFollowing, pendingAction) => IsFollowing !== pendingAction
)
